export const GET_LEAVE_DETAILS = "GET_LEAVE_DETAILS"
export const GET_LEAVE_DETAILS_RESPONSE = "GET_LEAVE_DETAILS_RESPONSE"
export const SET_RESPONSE = "SET_RESPONSE"
export const GET_LEAVE_ATTACHMENTS = "GET_LEAVE_ATTACHMENTS"
export const GET_LEAVE_ATTACHMENTSLIST = "GET_LEAVE_ATTACHMENTSLIST"
